import { Button } from "@/components/ui/button";
import { CalendarDays } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { buildStudyPlanICS, downloadICS } from "@/lib/icsExport";

interface Props {
  plan: any;
  examLabel?: string;
}

export function CalendarExportButton({ plan, examLabel }: Props) {
  const { toast } = useToast();

  const onExport = () => {
    try {
      // Flatten topic_name onto each task if available via a related lookup
      const ics = buildStudyPlanICS(plan, examLabel);
      const filename = `study-plan-${new Date().toISOString().split('T')[0]}.ics`;
      downloadICS(filename, ics);
      toast({
        title: "Calendar exported",
        description: "Open the .ics file with Google Calendar, Apple Calendar, or Outlook.",
      });
    } catch (e) {
      console.error(e);
      toast({
        title: "Export failed",
        description: "Could not generate calendar file.",
        variant: "destructive",
      });
    }
  };

  return (
    <Button variant="outline" size="sm" onClick={onExport} className="gap-2">
      <CalendarDays className="h-4 w-4" />
      Add to Calendar
    </Button>
  );
}
